export default function displayAsPhoneNumber(phoneNumber: string): string {
    const matches = phoneNumber.match("^(\\d{3})(\\d{3})(\\d{4})$");

    if(matches) {
        return matches[1] + " " + matches[2] + " " + matches[3];
    }

    return phoneNumber;
}